import {Controller} from "@hotwired/stimulus"

// Disables the form's submit button(s) as soon as the form is submitted, and
// (optionally) swaps their label to a "submitting" message. Prevents double
// submissions without relying on rails-ujs, and works with both Turbo and
// `turbo: false` forms.
//
// Usage (on the <form>):
//   data: {
//     controller: "disable-submit",
//     action: "submit->disable-submit#disable",
//     disable_submit_with_value: t("...submitting")
//   }
export default class extends Controller {
    static values = {with: String}

    get buttons() {
        return Array.from(
            this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
        )
    }

    connect() {
        // Re-enable on a fresh render or bfcache restore (back button).
        this.reset()
        this.resetHandler = () => this.reset()
        window.addEventListener("pageshow", this.resetHandler)
        document.addEventListener("turbo:submit-end", this.resetHandler)
    }

    disconnect() {
        window.removeEventListener("pageshow", this.resetHandler)
        document.removeEventListener("turbo:submit-end", this.resetHandler)
    }

    disable() {
        this.buttons.forEach((button) => {
            if (button.disabled) return

            if (this.hasWithValue && this.withValue.length) {
                button.dataset.disableSubmitLabel = this.label(button)
                this.setLabel(button, this.withValue)
            }

            // The form data is already serialized by the time the submit event
            // fires, so disabling synchronously is safe and still submits the form.
            button.disabled = true
        })
    }

    reset() {
        this.buttons.forEach((button) => {
            button.disabled = false

            if (button.dataset.disableSubmitLabel != null) {
                this.setLabel(button, button.dataset.disableSubmitLabel)
                delete button.dataset.disableSubmitLabel
            }
        })
    }

    label(button) {
        return button.tagName === "INPUT" ? button.value : button.innerHTML
    }

    setLabel(button, value) {
        if (button.tagName === "INPUT") {
            button.value = value
        } else {
            button.textContent = value
        }
    }
}
